import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

function MatomoTrackerAction() {
  const location = useLocation();

  useEffect(() => {
    if (!window._paq) {
      window._paq = [];
    }

    if (location.pathname == '/') {
      window._paq.push(['setCustomUrl', location.pathname]);
      window._paq.push(['setDocumentTitle', document.title]);
      window._paq.push(['trackPageView']);
    }
  }, [location]);

  const trackEvent = useCallback((category, action, name, value) => {
    if (!window._paq) {
      window._paq = [];
    }

    window._paq.push(['trackEvent', category, action, name, value]);
  }, []);

  const setUserId = useCallback((userId) => {
    if (!window._paq) {
      window._paq = [];
    }

    window._paq.push(['setUserId', userId]);
  }, []);

  return { trackEvent, setUserId };
}

export default MatomoTrackerAction;